module.exports = __webpack_public_path__ + "img/resourcesbg5.7c15197d.png";